import { render, staticRenderFns } from "./buddingModal.vue?vue&type=template&id=1dd45920&scoped=true"
import script from "./buddingModal.vue?vue&type=script&lang=js"
export * from "./buddingModal.vue?vue&type=script&lang=js"
import style0 from "./buddingModal.vue?vue&type=style&index=0&id=1dd45920&prod&scoped=true&lang=scss"
import style1 from "./buddingModal.vue?vue&type=style&index=1&id=1dd45920&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd45920",
  null
  
)

export default component.exports